import { Component} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Animations } from 'src/app/core/models/animations.model';
import { secureStorage } from 'src/app/core/secure.config';
import { getConfig, getConnection, hideSpinner, setOnLocal, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { GeneralsService } from 'src/app/core/services/generals.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    Animations.hidenHeightAnimation()
  ]
})
export class LoginComponent {
  public loading: boolean = false;
  public TITLE:string = "Inicia sesión";
  public form: FormGroup;
  hidePassword: boolean = true;


  constructor(private helpers: HelpersService,
    private activeRoute: ActivatedRoute, private formBuilder: FormBuilder,
    private authService: AuthService, private router: Router, private generalsService: GeneralsService) {
    const c_emp = getConnection()
    this.form = this.formBuilder.group({
      username: ["", [Validators.required]],
      password: ["", [Validators.required]],
      c_emp: [c_emp ? c_emp : "JA", [Validators.required]],
    });
    if (this.authService.isAuthenticated()) {
      this.router.navigate([getConfig("route_on_login")])
    }
    const data = this.activeRoute.snapshot.data
    if (data.title) {
      this.TITLE = data.title;
      this.helpers.setTitle(data.title);
    }
  }

  changeConnection(c_emp: string) {
    this.helpers.notifications.whiteMessage("Seleccionó: " + (c_emp == "JA" ? "Colombia" : (c_emp == "JP" ? "Panamá" : (c_emp == "JC" ? "Costa Rica" : "Ninguno"))))
    setOnLocal(environment.LOCAL_CONNECTION, c_emp)
    this.form.value.c_emp = c_emp;
  }

  async login(event: Event) {
    event.preventDefault()
    showSpinner()
    if (this.form.valid) {
      const response = await this.authService.verifyWithUsernameAndPassword(this.form.value)
      if (response.success) {
        if (response.data?.must_change_password) {
          this.router.navigate(['/auth/change-password'])
        } else {
          const lastUrl = secureStorage.getItem(environment.LOCAL_LAST_URL)
          this.helpers.notifications.successMessage("Acceso autorizado")
          await this.generalsService.getEndpoints(true)
          await this.generalsService.getRoles(this.form.value['username'], true)
          if (lastUrl) {
            location.href = lastUrl;
          } else {
            this.router.navigate([getConfig("route_on_login")])
          }
        }
      } else {
        this.helpers.notifications.errorMessage(response.message)
      }
    } else {
      this.helpers.notifications.warningMessage("Digite un nombre de usuario y contraseña válidos")
    }
    hideSpinner()
  }


  onUsernameInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    
    const uppercased = input.value.toUpperCase();

    this.form.get('username')?.setValue(uppercased, { emitEvent: false });
  }

}
